import Blue from "~/core";

new Blue({
	name: 'Home Hero',
	selector: ".hero-home",
	setup(hero) {
    const slides = [...hero.querySelectorAll(".hero-home__slide")];
		const slideContainer = hero.querySelector(".hero-home__slides");
    const imgs = [...hero.querySelectorAll(".hero-home__img")];
		const controlsContainer = hero.querySelector(".hero-home__controls");
		const prev = hero.querySelector("button.hero-home__prev");
		const next = hero.querySelector("button.hero-home__next");
		const control = hero.querySelector("button.hero-home__control");
		const currentNumber = hero.querySelector("span.hero-home__current");
		const totalNumber = hero.querySelector("span.hero-home__total");
		let slideHeight = slideContainer.offsetHeight;
		const slideTime = 7000;
		let slideInterval;
		let paused = false;

		control.setAttribute("aria-label", "Pause slideshow");
		
		const setSlideInterval = () => {
			if (typeof(slideInterval) === 'undefined') {
				slideInterval = setInterval(() => {
					moveSlide(1);
				}, slideTime);
			}
		}

		
		if (slides.length === 1) {
			controlsContainer.remove();
		} else {
			totalNumber.innerHTML = slides.length;
			setSlideInterval();
		}

		const moveSlide = (directionNumber) => {
			clearInterval(slideInterval);
			slideInterval = undefined;
			if (!paused) setSlideInterval();
			let index;
			slides.forEach((slide, i) => {
				if (slide.matches(".active")) index = i;
			});
			hero.querySelector(".hero-home__img.active").classList.remove("active");
			hero.querySelector(".hero-home__slide.active").classList.remove("active");
			if (index === slides.length - 1 && directionNumber === 1) {
				index = -1;
			} else if (index === 0 && directionNumber === -1) {
				index = slides.length;
			}
			slides[index + directionNumber].classList.add("active");
			imgs[index + directionNumber].classList.add("active");
			slideContainer.animate(
				[
					{
						height: slideHeight + "px"
					},
					{
						height: slideContainer.offsetHeight + "px"
					}
				],
				{
					duration: 500,
					easing: 'ease'
				}
			);
			slideHeight = slideContainer.offsetHeight;
			currentNumber.innerHTML = (index + 1) + directionNumber;
		}

		this.$addEvents(next, "click", () => {moveSlide(1)});
		this.$addEvents(prev, "click", () => {moveSlide(-1)});

		this.$addEvents(control, "click", () => {
			control.classList.toggle("hero-home__pause");
			control.classList.toggle("hero-home__play");
			if (control.matches(".hero-home__play")) {
				control.setAttribute("aria-label", "Play slideshow");
				clearInterval(slideInterval);
				slideInterval = undefined;
				paused= true;
			} else {
				control.setAttribute("aria-label", "Pause slideshow");
				moveSlide(1);
				setSlideInterval();
				paused = false;
			}
		});

		// Intersection Observer to Pause When Not on Screen
		const handleIntersect = (entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {	
					setSlideInterval();
					paused = false;
				} else {
					clearInterval(slideInterval);
					slideInterval = undefined;
					paused= true;
				}
			})
		}
		const options = {
			threshold: [0]
		}
		const observer = new IntersectionObserver(handleIntersect, options);
		observer.observe(hero);
		
	}
});